import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/** Los colaboradores sin contrato, debajo de Nómina. Adjudicación 301. */
export const rutaColaboradores = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/colaboradores',
  component: lazyRouteComponent(() => import('./colaboradores-pantalla.js'), 'RutaColaboradores'),
});
